 <!-- Modal -->
    <div class="modal fade" id="editPayModal" tabindex="-1" role="dialog" aria-labelledby="editPayModalLabel" aria-hidden="true">
        <div *ngIf="installmentData" class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editPayModalLabel">Pago: {{ installmentData.installmentNumber }} | Contrato: {{ installmentData.idContract }} </h5>
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="editPayForm" (ngSubmit)="editPayment()">
            <div class="modal-body">
                <div class="form-group">
                    <label for="reference">Número de refencia</label>
                    <input type="text"  class="form-control" id="reference" formControlName="reference">
                </div>
                <div class="form-group">
                    <label for="paid">Pagado</label>
                    <select class="form-control" id="paid" formControlName="paid">
                        <option value="true">Pagado</option>
                        <option value="false">Pendiente</option>
                    </select>
                </div>    
            </div>
            <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
                Falta algun campo...
            </div>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                Error intente luego...
            </div>
            <div class="modal-footer">
                
                <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
            </form>
            </div>
        </div>
        </div>